import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useStopwatch } from 'react-timer-hook'
import * as S from './ReceivementPurchase.styles'
import { actions } from '../../ReceivementState'
import { selectSalesAwaitStatus } from '../../ReceivementSelectors'
import { useStore } from 'src/utils/store'

const Watch: React.FC = React.memo(() => {
  const dispatch = useDispatch()
  const store = useStore()

  const {
    seconds, minutes, hours, pause,
  } = useStopwatch({ autoStart: true })

  const
    awaitStatus = useSelector(
      selectSalesAwaitStatus,
    ) ?? ''

  const { receivementId } = useParams<{ receivementId?: string }>()

  const resolveWaitingTime = React.useCallback(
    () => {
      const { isLoading } = store.getState().app

      if (seconds === 0 && minutes !== 0 && !!receivementId && !isLoading) {
        dispatch(
          actions.getSalesOverview({
            receivementId,
          }),
        )
      }
      return `${`0${hours}`.slice(-2)}:${`0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`
    },
    [dispatch, hours, minutes, receivementId, seconds, store],
  )

  React.useEffect(
    () => () => {
      pause()
    },
    // Disabled because react timer hook doesn't return memoized functions
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return (
    <>
      <S.Title>Recebimento: {receivementId}</S.Title>
      <S.StatusText>Status do recebimento: {awaitStatus.toLowerCase()}</S.StatusText>
      <S.StatusText>Tempo aguardando: {resolveWaitingTime()}</S.StatusText>
    </>
  )
})

export { Watch }
